import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RouterMain from './router';
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey('Boltrack_SRL_DataTerra_1Devs3_January_2020__MTU3ODAzMTIwMDAwMA==1b0705b2298ea9f53185128e48770b09');
// import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterMain />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
